/* custom helpers */
import { Core } from './Core.js';

/* templates */
import { dropdownOption } from './../../templates/dropdown.js';
import { listContainer, listItem } from './../../templates/list.js';

/** ----------------------------------------
    Filter
 ---------------------------------------- */

/**
 * This class is where the custom code for
 * the project lives. It inherits all the
 * functionality from the Core class.
 */

export class Filter extends Core {

    constructor(config, host) {
        super();

        let template = document.body.dataset.template;

        if (template !== 'program')
            return;

        this.config = config;
        this.form = [];
        this.host = host;
        this.init();
    }

    /** ----------------------------------------
        Type Helpers
     ---------------------------------------- */

    checkType(value) {
        return value.split('-')[1];
    }

    /** ----------------------------------------
        Set Filters
     ---------------------------------------- */

    filters() {
        let mapping = this.store.get('data.mapping');
        let options = document.querySelectorAll('.dropdown__options');

        [...options].map(filter => {
            this.form = filter.getElementsByTagName('form')[0];
            let type = this.checkType(this.form.id);

            mapping.data[type].map(option => {
                this.form.insertAdjacentHTML('beforeend', dropdownOption(option, ''));
            });

            this.setFilterEvents(this.form);
        });
    }

    /** ----------------------------------------
        Set Filters Events
     ---------------------------------------- */

    setFilterEvents(form) {
        let inputs = form.querySelectorAll('input');
        this.selectEvent(inputs);
    }

    events() {
        this.on('filter', function listener(event) {
            let type = this.checkType(event.parent);
            this._selected(type, event.value);
            this.filter();
        });

        this.on('remove-filter', function listener(event) {
            let form = document.querySelector(`#filter-${event.type}`);
            let formOptionInputs = form.querySelectorAll('input');
            [...formOptionInputs].map(inputOption => {
                if(inputOption.checked && inputOption.id == event.value) {
                    inputOption.checked = false;
                }
            });

            this._selected(event.type, event.value);
            this.filter();
        });
    }

    /** ----------------------------------------
        Events
     ---------------------------------------- */

    days() {
        let days = this.store.get('selected.days');
        let collection = this.store.get('data.items');
        let matches = [];

        collection.data.map((obj, i) => {
            if (days.data.includes(obj.days_value)) {
                matches.push(obj);
            }
            return;
        });

        return matches;
    }

    locations(data) {
        let locations = this.store.get('selected.locations');
        let collection = this.store.get('data.items');
        let matches = [];

        collection.data.map((obj, i) => {
            if (obj.programs.find(o => locations.data.includes(o.locations_value))) {
                matches.push(obj);
            }
            return;
        });

        let programMatches = [];

        matches.map(match => {
            let copiedMatch = JSON.parse(JSON.stringify(match));
            copiedMatch.programs = copiedMatch.programs.filter(p => locations.data.includes(p.locations_value));
            if(copiedMatch.programs.length > 0) {
                programMatches.push(copiedMatch);
            }
        });

        return programMatches;
    }

    genres(data) {
        // let genres = this.store.get('selected.genres');
        //
        // console.log('genres', genres);
        //
        // if(genres) {
        //     if (!data) data = this.store.get('results').take();
        //     genres.data.map(genre => this.produce('genre', genre, data));
        // }
    }

    locationsAndDays() {
        let days = this.store.get('selected.days');
        let locations = this.store.get('selected.locations');
        let collection = this.store.get('data.items');
        let dayMatches = [];

        // filter the days out
        collection.data.map((obj, i) => {
            if (days.data.includes(obj.days_value)) {
                dayMatches.push(obj);
            }
            return;
        });

        // from the remaining days, adjust the programs to match the selected location(s)
        let matches = [];

        dayMatches.map((obj, i) => {
            // console.log(locations.data, obj.programs);
            if (obj.programs.find(o => locations.data.includes(o.locations_value))) {
                matches.push(obj);
            }
            return;
        });

        let programMatches = [];

        matches.map(match => {
            let copiedMatch = JSON.parse(JSON.stringify(match));
            copiedMatch.programs = copiedMatch.programs.filter(p => locations.data.includes(p.locations_value));
            if(copiedMatch.programs.length > 0) {
                programMatches.push(copiedMatch);
            }
        });

        return programMatches;
    }

    filter() {
        let days = this.store.get('selected.days');
        let locations = this.store.get('selected.locations');

        let matches = this.store.get('data.items').take();

        this.store.add(matches, true);

        if(locations && locations.data.length > 0 && days && days.data.length > 0) {
            matches = this.locationsAndDays();
        } else if(locations && locations.data.length > 0) {
            matches = this.locations();
        } else if(days && days.data.length > 0) {
            matches = this.days();
        }

        this.store.add(matches, true);
        this.setSelectedFilters();

        // this.days();
        // this.locations();
        // this.genres();
    }

    select(type, data) {
        // this.days(data);
        // this.locations(data);
        // this.genres(data);
    }

    /** ----------------------------------------
        Produce
     ---------------------------------------- */

    produce(type, value, data = 'temp') {
        let results = [];

        switch (type) {

        case 'day':
            results = this.store
                .get('data.items')
                .filter('days_value', value)
                .take();

            break;

        case 'genre':
            results = this.store
                .get('data.items')
                .filter('genres_value', value)
                .take();
            break;

        case 'location':
            results = this.store
                .get('data.items')
                .filter('locations_value', value)
                .take();

            break;

        default:
            results = 'No results!';
        }

        this.store.park(results, type);
    }

    /** ----------------------------------------
        Sort Results
     ---------------------------------------- */

    sort(data) {
        return this.store
            .set(data)
            .sortBy('date')
            .take();
    }

    /** ----------------------------------------
        Results
     ---------------------------------------- */

    results() {
        this.default('data.items', 3);

        this.on('results', function listener(result) {
            let html = this.sort(result.data).map(days => {
                if(days.programs.length === 0)
                    return;

                return listContainer(days, days.programs.map(item => {
                    return listItem(item, days)
                }));
            });

            this.build(html);
        });
    }

    /** ----------------------------------------
     Selected filters
     ---------------------------------------- */

    setSelectedFilters() {
        let days = this.store.get('selected.days');
        let locations = this.store.get('selected.locations');

        let filterContainer = document.querySelector('#js-selected-filters');
        filterContainer.innerHTML = '';

        if(locations && locations.data.length > 0) {
            locations.data.map(location => {
                let html = this.buildSelectedFilterLocationHtml(location);
                filterContainer.insertAdjacentHTML('beforeend', html);
            });
        }

        if(days && days.data.length > 0) {
            days.data.map(day => {
                let html = this.buildSelectedFilterDayHtml(day);
                filterContainer.insertAdjacentHTML('beforeend', html);
            });
        }

        let filterBtns = filterContainer.querySelectorAll('button');
        [...filterBtns].map(btn => btn.addEventListener('click', (event) => {
            this.emit('remove-filter', {
                value: event.target.dataset['filter'],
                type: event.target.dataset['type'],
                element: btn,
                event: event
            });

            this.update();
        }, {
            once: true,
        }));
    }

    buildSelectedFilterLocationHtml(location) {
        let mapping = this.store.get('data.mapping');
        let locationLabel = mapping.data.locations.find(l => l.value == location).name;

        let html = `
            <div class="selected-filters__element">
                <span class="selected-filters__element--text">${locationLabel}</span>
                <button data-type="locations" data-filter="${location}" class="selected-filters__element--button">x</button>
            </div>
        `;

        return html;
    }

    buildSelectedFilterDayHtml(day) {
        let mapping = this.store.get('data.mapping');
        let dayLabel = mapping.data.days.find(d => d.value == day).name;

        let html = `
            <div class="selected-filters__element">
                <span class="selected-filters__element--text">${dayLabel}</span>
                <button data-type="days" data-filter="${day}" class="selected-filters__element--button">x</button>
            </div>
        `;

        return html;
    }



    /** ----------------------------------------
        Init
     ---------------------------------------- */

    /**
     * This function is called within the
     * constructor and will initiate once the
     * class is loaded. A promise is from the
     * core class.
     */

    init() {
        this._feed();

        this.on('ready', function listener() {
            this.filters();
            this.events();
            this.results();
        });
    }
}